import { render } from "./ChangeLanguage.vue?vue&type=template&id=cff7dc50&scoped=true"
import script from "./ChangeLanguage.vue?vue&type=script&lang=js"
export * from "./ChangeLanguage.vue?vue&type=script&lang=js"

import "./ChangeLanguage.vue?vue&type=style&index=0&id=cff7dc50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cff7dc50"]])

export default __exports__